import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useIntercom } from "@/composables/intercom";

export function useDeepLinking<T extends BaseEntity>(routeName: string) {
  const { toggleIntercom } = useIntercom();

  const route = useRoute();
  const router = useRouter();

  const openOnRoute = ref(true);
  const selectedId = ref("");
  const addDrawerVisible = ref(false);
  const editDrawerVisible = ref(false);

  const openAddDrawer = () => {
    addDrawerVisible.value = true;
    toggleIntercom(false);
    openOnRoute.value = false;
    router.push({
      name: routeName,
      params: { id: "new" },
    });
  };

  const closeAddDrawer = async () => {
    addDrawerVisible.value = false;
    toggleIntercom(true);
    await router.push({
      name: routeName,
    });
  };

  const openEditDrawer = (row: T) => {
    selectedId.value = row.id;
    openOnRoute.value = false;
    editDrawerVisible.value = true;
    toggleIntercom(false);

    if (selectedId.value === "update") {
      return;
    }

    router.push({
      name: routeName,
      params: { id: row.id },
    });
  };

  const closeEditDrawer = async () => {
    editDrawerVisible.value = false;
    toggleIntercom(true);
    await router.push({
      name: routeName,
    });
  };

  watch(
    () => route,
    () => {
      if (route.name !== routeName) return;

      if (!route.params.id) {
        addDrawerVisible.value = false;
        editDrawerVisible.value = false;
        return;
      }

      if (route.params.id === "new") {
        openAddDrawer();
        return;
      }

      selectedId.value = route.params.id as string;
      editDrawerVisible.value = true;

      toggleIntercom(false);
    },
    {
      deep: true,
      immediate: true,
    }
  );

  return {
    selectedId,
    addDrawerVisible,
    editDrawerVisible,
    openOnRoute,
    openAddDrawer,
    closeAddDrawer,
    openEditDrawer,
    closeEditDrawer,
  };
}
